import { patch } from '../../../helpers/fetch';
import { buildURL, urls } from '../../../helpers/urls';

// eslint-disable-next-line import/prefer-default-export
export const updateLanguage = (event) => {
  const url = buildURL(urls.events.root, urls.events.language);
  return patch(url, event);
};
